module.exports = __webpack_public_path__ + "static/img/Duop-Reath.c1beca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Duop-Reath.jpg
// module id = gzXy
// module chunks = 1